import React from 'react';
import { string } from '../../localization';
import './LoadMoreContentsTemplate.scss';
import { Icons } from '../../utilities/Icons/Icons';

const LoadMoreContentsTemplate = () => (
  <div className='load-more-container'>
    <img className='center-image' id='loading' src={Icons.loading} alt='' />
    <label htmlFor='loading' className='more-loading-label'>
      {string.LOADING_KEY}
    </label>
  </div>
);

export default LoadMoreContentsTemplate;
